export default () => ({
  // Reference data (lazy hydration, persists in-memory until logout)
  pipelines: [],
  leadSources: [],
  usersById: {},
  referenceLoaded: false,
  referenceLoading: false,
  referenceError: null,

  // View state (persisted: viewMode/currentPipelineId/filters — REQ-02b)
  currentPipelineId: null,
  viewMode: "kanban",
  filters: { q: "", source_id: null, assigned_to_id: null, pipeline_stage_id: null, archived: false },
  // FT-154: серверные фильтры доски (unread=true / important=true в leads#board) — считаются по
  // всей стадии, а не по загруженному окну; в URL как unread=true / important=true. Getter-фильтр
  // leadsForStage остаётся страховкой. В fetchLeadsList не уходят (вид «Список» вне scope).
  unreadOnly: false,
  importantOnly: false,
  // FT-156 REQ-07: свёрнутые колонки доски по воронке: { [pipeline_id]: [stage_id, …] }.
  // Нет записи для воронки — дефолт (терминальные won/lost свёрнуты), считает getter
  // isStageCollapsed. Персистится crmPersistReducer.
  collapsedStages: {},

  // List view
  leadsList: { items: [], meta: { total_count: 0, page: 1, per_page: 50, total_pages: 0, next_page: null, prev_page: null }, loading: false, error: null },

  // Inbox view — плоский список непрочитанных через все стадии (серверный, пагинируемый)
  inbox: { items: [], meta: { total_count: 0, page: 1, per_page: 30, total_pages: 0, next_page: null, prev_page: null }, loading: false, error: null },

  // Kanban. Бакет стадии — makeBucket() из mutations.js: { items, page, total, unreadCount,
  // hasMore, loadingMore, countsStale } (FT-154 REQ-10). kanbanLoading — только первичная загрузка
  // (доска размонтирует колонки); catch-up по реконнекту идёт под catchingUp, колонки живут и
  // держат scrollTop. catchUpPending — connected пришёл во время загрузки/догрузки, catch-up
  // запустится один раз по её завершении. boardGeneration — номер полной загрузки доски
  // (fetchLeadsForKanban без catch-up): ответы, начатые при прежнем номере, к доске не относятся.
  leadsByStage: {},
  boardGeneration: 0,
  kanbanLoading: false,
  kanbanError: null,
  catchingUp: false,
  catchUpPending: false,

  // Drawer
  selectedLeadId: null,
  selectedLead: null,
  selectedLeadLoading: false,
  selectedLeadError: null,

  // Optimistic ops
  pendingMoves: {},

  // Conversion sessions (FT-056, мульти): по сессии на лида, пока менеджер ищет машину.
  // draft переживает уход со страницы (даты + выбранная машина); persisted (crmPersist).
  conversions: [],

  // FT-171 ассистент CRM: flag — { enabled, mode } из leads#detail (null — ничего не рисуем);
  // latest — последний ответ latest для leadId: { suggestion, current } или null.
  assistant: { flag: null, leadId: null, latest: null },
  // Inbox (045b)
  leadMessages: { items: [], identity: null, hasMore: false, loading: false, error: null },
  replySending: false,

  // Activities (046a)
  leadActivities: { items: [], meta: null, loading: false, error: null, creating: false },

  websiteChatSessions: {},
  chatWidgets: [],
  chatWidgetDirectories: { companies: [], locations: [] },

  // Tasks (046b)
  leadTasks: { items: [], meta: null, loading: false, error: null, creating: false },
  myTasks: { items: [], meta: null, loading: false, error: null },
  assignableUsers: [],
});
